import React from "react"

import styles from "./Tabs.module.scss"

import Container from "components/Container/Container"
import Tab from "components/Tab/Tab"

/**
 *
 * @param {String} [className] - additional className to add to wrapper
 * @param {Object[]} tabs - tabs to show
 * @param {String} tabs[].heading - tab heading
 * @param {String} tabs[].icon - tab icon
 * @param {String} activeTab - currently active tab
 * @param {Function} setActiveTab - function to set active tab in parent
 */
const Tabs = props => {
    return (
        <div className={`${styles["dashboard-tabs"]} ${props.className ? styles[props.className] : ''}`}>
            <div className={styles.tabs}>
                <Container wide className={styles["tabs-container"]}>
                    {props.tabs.map((el, index) => (
                        <Tab
                            key = {`key-tab-${index}`}
                            heading = {el.heading}
                            count = {el.count}
                            icon = {el.icon}
                            active = {
                                props.activeTab === el.heading ? true : false
                            }
                            onClick = {props.setActiveTab(el.heading)}
                        />
                    ))}
                </Container>
            </div>
            <div className={styles["tabs-content"]}>{props.children}</div>
        </div>
    )
}

export default Tabs
